import {
  ControlPosition,
  MapControl,
  useMap,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Dropdown, Form, ListGroup, Spinner } from "react-bootstrap";
import { DebounceInput } from "react-debounce-input";
// import ReactDOM from "react-dom";

const GoogleSearch = ({ children }) => {
  const map = useMap();
  const [input, setInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showing, setShowing] = useState(false);

  const [selectedPlace, setSelectedPlace] = useState();
  const placesLib = useMapsLibrary("places");
  const sessionTokenRef = useRef(null);

  useEffect(() => {
    if (!placesLib) return;

    const { AutocompleteSessionToken, AutocompleteSuggestion } = placesLib;

    // Create a new session if one doesn't already exist. This has to be reset
    // after `fetchFields` for one of the returned places is called by calling
    // the `resetSession` function returned from this hook.
    if (!sessionTokenRef.current) {
      sessionTokenRef.current = new AutocompleteSessionToken();
    }

    const request = {
      input: input,
      sessionToken: sessionTokenRef.current,
      locationBias: map.getCenter(),
    };

    if (input === "") {
      if (suggestions.length > 0) setSuggestions([]);
      return;
    }

    setLoading(true);
    AutocompleteSuggestion.fetchAutocompleteSuggestions(request)
      .then((res) => {
        setSuggestions(res.suggestions);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [input]);

  const handleSuggestionClick = useCallback(
    async (suggestion) => {
      if (!placesLib) return;
      if (!suggestion.placePrediction) return;

      const place = suggestion.placePrediction.toPlace();

      await place.fetchFields({
        fields: [
          "viewport",
          "location",
          "svgIconMaskURI",
          "iconBackgroundColor",
        ],
      });

      setInput("");

      // calling fetchFields invalidates the session-token, so we now have to call
      // resetSession() so a new one gets created for further search
      // resetSession();
      sessionTokenRef.current = null;
      setSuggestions([]);

      setSelectedPlace(place);
      //onPlaceSelect(place);
    },
    [placesLib]
  );
  useEffect(() => {
    if (!map || !selectedPlace) return;
    if (selectedPlace.viewport) map.fitBounds(selectedPlace.viewport);
  }, [map, selectedPlace]);

  return (
    <MapControl position={ControlPosition.TOP_RIGHT}>
      <div
        className="d-flex justify-content-between align-items-center px-2"
        style={{
          background: "#ffffffff",
          margin: "10px",
          width: "250px",
          height: "40px",
          borderRadius: "2px",
        }}
      >
        <DebounceInput
          className="hashtag-input text-gray w-100 mx-0 px-1"
          style={{
            border: "1px solid #7f838e",
            borderRadius: "3px",
            fontSize: "12px",
            maxHeight: "32px",
          }}
          minLength={0}
          debounceTimeout={500}
          value={input}
          placeholder="Search for a place..."
          onClick={(e) => e.stopPropagation()}
          onFocus={(e) => {
            setShowing(true);
          }}
          onChange={(event) => {
            setInput(event.target.value);
          }}
        />

        {loading && (
          <div className="w-100 position-relative bg-light d-flex justify-content-center">
            <Spinner animation="border" />{" "}
          </div>
        )}
      </div>
      <div
        style={{ maxHeight: "500px", maxWidth: "250px" }}
        className="overflow-auto position-relative px-2"
      >
        {showing && !loading && (
          <ListGroup>
            {suggestions.map((suggestion, i) => {
              return (
                <div className="bg-light" key={i}>
                  <ListGroup.Item
                    onClick={(event) => {
                      event.stopPropagation();
                      handleSuggestionClick(suggestion);
                    }}
                    className="cursor-pointer list-group-hover p-2"
                  >
                    {suggestion.placePrediction?.text.text}
                  </ListGroup.Item>
                </div>
              );
            })}
          </ListGroup>
        )}
      </div>

      <div
        className="z-100 w-100"
        hidden={true}
        // className="d-flex flex-column bd-highlight p-2 mb-3 align-items-end"
        // style={{ width: "260px" }}
      >
        <Form.Control
          autoFocus
          // className="p-1 m-0 w-100 b-1"
          placeholder="Search for a place..."
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            console.log("kkd", e);
          }}
          value={input}
          className="hashtag-input text-gray w-100"
          style={{
            border: "1px solid #7f838e",
            padding: "4px 8px",
            fontSize: "12px",
            height: "32px",
            margin: "10px 10px",
          }}
        />

        <Dropdown.Menu
          show={suggestions.length > 0}
          className="p-0 m-0 border bg-white w-100 z-100 "
          bsPrefix="map"
          onSelect={(e) => {
            console.log("dd", e);
          }}
          align={"end"}
        >
          {suggestions.map((suggestion, i) => (
            <Dropdown.Item
              key={i}
              className="p-1 m-0 d-inline-block text-truncate"
              onClick={() => handleSuggestionClick(suggestion)}
            >
              {suggestion.placePrediction?.text.text}
            </Dropdown.Item>
          ))}

          {/* <Dropdown.Item eventKey="2">Another action</Dropdown.Item> */}
          {/* <Dropdown.Item eventKey="3">Something else here</Dropdown.Item> */}
          {/* <Dropdown.Divider /> */}
          {/* <Dropdown.Item eventKey="4">Separated link</Dropdown.Item> */}
        </Dropdown.Menu>
      </div>
      {/* <ul className="list-unstyled">
        {suggestions.map(({ placePrediction }) => (
          <li key={placePrediction.placeId}>{placePrediction.text.text}</li>
        ))}
      </ul> */}
    </MapControl>
  );

  // const map = useMap();

  // useEffect(() => {
  //   if (!map) return;

  //   const controlButton = document.createElement("button");

  //   // Set CSS for the control.
  //   controlButton.style.backgroundColor = "#fff";
  //   controlButton.style.border = "2px solid #fff";
  //   controlButton.style.borderRadius = "3px";
  //   controlButton.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
  //   controlButton.style.color = "rgb(25,25,25)";
  //   controlButton.style.cursor = "pointer";
  //   controlButton.style.fontFamily = "Roboto,Arial,sans-serif";
  //   controlButton.style.fontSize = "16px";
  //   controlButton.style.lineHeight = "38px";
  //   controlButton.style.margin = "8px 8px";
  //   controlButton.style.padding = "0 5px";
  //   controlButton.style.textAlign = "center";
  //   controlButton.textContent = "Center Map";
  //   controlButton.title = "Click to recenter the map";
  //   controlButton.type = "button";
  //   // Setup the click event listeners: simply set the map to Chicago.
  //   controlButton.addEventListener("click", () => {
  //     map.setCenter({ lat: 41.85, lng: -87.65 });
  //   });

  //   // const root = React.createRoot(domNode);
  //   // root.render();
  //   // document.body.appendChild(domNode); // You can add it anywhere in the document

  //   // var html = ;
  //   map.controls[ControlPosition.TOP_RIGHT].push(controlButton);

  //   return () => {
  //     map.controls[ControlPosition.TOP_RIGHT].push(controlButton);
  //   };
  // }, [map]);

  // return <React.Fragment></React.Fragment>;
};

export default GoogleSearch;
